import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href="https://wa.me/918800889959"
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="Chat with us on WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer group"
      style={{ filter: 'drop-shadow(0 4px 12px rgba(37,211,102,0.4))' }}
    >
      {/* Tooltip label */}
      <div
        className={`bg-stone-900 text-white text-xs font-semibold px-3 py-2 rounded-full whitespace-nowrap transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        Chat with us!
      </div>

      {/* Button */}
      <div className="relative w-14 h-14 flex items-center justify-center">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
        <div className="relative w-14 h-14 bg-[#25D366] hover:bg-[#20c05a] rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </div>
      </div>
    </a>
  );
}
